var installPrompt;
window.addEventListener('beforeinstallprompt', function(e) {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault();
  // Stash the event so it can be triggered later.
  installPrompt = e;
});
$("#langtomo-install-app").click(function() {
  installPrompt.prompt();
});


